import { React, useState, useEffect } from 'react';
import { Nav, Modal } from 'react-bootstrap';
import '../../settingscommon.scss';
import '../../User/user.scss';
import '../../EmailProvider/emailprovider.scss';
import '../../EmailProvider/GoogleEmail/googleemail.scss';
import { Link, withRouter } from 'react-router-dom';
import warningIcon from '../../../../assets/images/warningIcon.svg';
import { useMutation } from '@apollo/client';
import { REMOVE_GMAIL_LINKED } from '../../../../gql/gmail/mutation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLazyQuery } from '@apollo/client';
import { GET_PROFILE } from '../../../../gql/auth/queries';
import { GET_LINKED_GMAIL_DATA, GET_GMAIL_ALIAS } from '../../../../gql/gmail/queries';
// import { Spinner } from 'react-bootstrap';

function GoogleEmail({ history }) {
  const [smShow, setSmShow] = useState(false);
  const [removed, setRemoved] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [linkedGmail, setLinkedGmail] = useState('')
  const [linkedGmailName, setLinkedGmailName] = useState('')
  const [gmailAlias, setGmailAlias] = useState([])

  const [loadUser] = useLazyQuery(GET_PROFILE, {
    onCompleted(data) {
      if (data?.me?.emailProvider === null || data?.me?.emailProvider === "smtp") {
        history.push('/settings/email-provider')
      }
    },
    fetchPolicy: "network-only",
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    }
  });

  const [removeLink] = useMutation(REMOVE_GMAIL_LINKED, {
    onCompleted(data) {
      if (data) {
        setRemoved(true)
      }
    },
    refetchQueries: ['Me'],
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    }
  })

  const [getLinkedGmail] = useLazyQuery(GET_LINKED_GMAIL_DATA, {
    onCompleted(data) {
      setLinkedGmail(data?.getGmailAuthData?.email)
      setLinkedGmailName(data?.getGmailAuthData?.name)

      setGmailAlias(data?.getGmailAuthData?.aliases)
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    }

  })

  const [getGmailAlias, { loading }] = useLazyQuery(GET_GMAIL_ALIAS, {
    onCompleted(data) {
      setGmailAlias(data?.getGmailAliases)
    },
    fetchPolicy: "network-only",
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")  
        }
      }
    }
  })

  useEffect(() => {
    loadUser()
    getLinkedGmail()
    // getGmailAlias()
    // eslint-disable-next-line
  }, [])

  const handleUnlink = () => {
    removeLink()
  }

  if (removed) {
    history.push('/settings/email-provider')
  }


  if (errorMessage) {
    toast.error(errorMessage, {
      position: "bottom-right",
      closeOnClick: true,
    })
    setErrorMessage('')
  }

  const handleGoogleAlias = () => {
    getGmailAlias()
  }


  return <>
    <div>
      <h1 className='page-title'>Settings</h1>
      <Nav
        className='setting-menu'
      >
        <Nav.Item>
          <Link to="/settings/user" className='nav-link'>User</Link>
        </Nav.Item>
        <Nav.Item>
          <Link to="/settings/email-provider" className='nav-link active'>Email Provider</Link>
        </Nav.Item>
        <Nav.Item>
          <Link to="/settings/text-provider" className='nav-link'>SMS Provider</Link>
        </Nav.Item>
        <Nav.Item>
          <Link to="/settings/email-signature" className='nav-link'>Email Signature</Link>
        </Nav.Item>
        {/* <Nav.Item>
                <Link to="/settings/billing" className='nav-link'>Billing</Link>
            </Nav.Item> */}
      </Nav>
      <div className='google-email-sec'>
        <p>You are using Google email provider with the account <a href={`mailto:${linkedGmail}`}>{linkedGmail}</a></p>
        {/* <p>Warning: If you use a Gmail alias and want to track replies in OmniOutreach, be sure to setup an imap and/or forward rules.</p> */}
        <h4>Google aliases</h4>
        <p>Here is the list of Google aliases. Press Refresh to get new data from Google.</p>
        <ul>
          {
            gmailAlias && gmailAlias.map((item, idx) => (
              // eslint-disable-next-line
              <li key={idx}>{item.displayName ? item.displayName : linkedGmailName} &lt;{item?.sendAsEmail}&gt; {item?.isDefault == true ? "(Google status: primary)" : ""}</li>
            ))
          }
        </ul>
        {
          loading ?
            <button className='solid-button refresh-btn'>
              <svg className='rotate' fill="#fff" width="20px" height="20px" viewBox="0 0 92.33 92.33">
                <g>
                  <path d="M70.598,16.753c-1.722-1.24-4.113-0.852-5.349,0.866c-1.242,1.716-0.853,4.113,0.865,5.35c13.613,9.818,18.021,27.857,10.482,42.89c-4.082,8.138-11.088,14.202-19.726,17.066c-8.636,2.871-17.877,2.2-26.013-1.879c-8.134-4.083-14.197-11.088-17.066-19.722c-2.866-8.642-2.197-17.877,1.886-26.014c4.958-9.89,14.458-16.779,25.413-18.429c0.074-0.008,0.137-0.036,0.211-0.053l0.157,7.571c0.021,0.839,0.542,1.585,1.321,1.889c0.782,0.305,1.672,0.11,2.25-0.496l10.904-11.379c0.794-0.828,0.764-2.142-0.062-2.933L44.492,0.577c-0.606-0.582-1.499-0.739-2.267-0.399c-0.251,0.108-0.476,0.269-0.662,0.462c-0.372,0.389-0.585,0.919-0.579,1.479l0.151,7.212c-0.385-0.063-0.78-0.087-1.188-0.027c-13.418,2.021-25.052,10.46-31.125,22.571C-1.499,52.451,6.85,77.584,27.424,87.901c5.989,3.005,12.362,4.429,18.646,4.429c15.306,0,30.065-8.439,37.382-23.028C92.688,50.884,87.284,28.782,70.598,16.753z" />
                </g>
              </svg>
              Refresh Google Aliase
              {/* <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              /> */}
            </button>
            :
            <button className='solid-button refresh-btn' onClick={handleGoogleAlias}>
              <svg fill="#fff" width="20px" height="20px" viewBox="0 0 92.33 92.33">
                <g>
                  <path d="M70.598,16.753c-1.722-1.24-4.113-0.852-5.349,0.866c-1.242,1.716-0.853,4.113,0.865,5.35c13.613,9.818,18.021,27.857,10.482,42.89c-4.082,8.138-11.088,14.202-19.726,17.066c-8.636,2.871-17.877,2.2-26.013-1.879c-8.134-4.083-14.197-11.088-17.066-19.722c-2.866-8.642-2.197-17.877,1.886-26.014c4.958-9.89,14.458-16.779,25.413-18.429c0.074-0.008,0.137-0.036,0.211-0.053l0.157,7.571c0.021,0.839,0.542,1.585,1.321,1.889c0.782,0.305,1.672,0.11,2.25-0.496l10.904-11.379c0.794-0.828,0.764-2.142-0.062-2.933L44.492,0.577c-0.606-0.582-1.499-0.739-2.267-0.399c-0.251,0.108-0.476,0.269-0.662,0.462c-0.372,0.389-0.585,0.919-0.579,1.479l0.151,7.212c-0.385-0.063-0.78-0.087-1.188-0.027c-13.418,2.021-25.052,10.46-31.125,22.571C-1.499,52.451,6.85,77.584,27.424,87.901c5.989,3.005,12.362,4.429,18.646,4.429c15.306,0,30.065-8.439,37.382-23.028C92.688,50.884,87.284,28.782,70.598,16.753z" />
                </g>
              </svg>
              Refresh Google Aliase
            </button>

        }
        <button className='solid-button' onClick={() => setSmShow(true)}>
          <svg fill='#fff' width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M5.63603897,5.63603897 L11.289,11.289 L13.4213562,9.15728753 C13.8138529,8.76479084 14.4502158,8.76479084 14.8427125,9.15728753 C15.2352092,9.54978421 15.2352092,10.1861471 14.8427125,10.5786438 L12.71,12.71 L18.363961,18.363961 C18.7544853,18.7544853 18.7544853,19.3876503 18.363961,19.7781746 C17.9734367,20.1686989 17.3402718,20.1686989 16.9497475,19.7781746 L14.139,16.968 L10.5786438,20.5281374 C8.61616033,22.4906209 5.43434601,22.4906209 3.47186258,20.5281374 C1.56102344,18.6172983 1.5107382,15.5504592 3.32100685,13.5787779 L3.47186258,13.4213562 L7.032,9.861 L4.22182541,7.05025253 C3.83130112,6.65972824 3.83130112,6.02656326 4.22182541,5.63603897 C4.6123497,5.24551468 5.24551468,5.24551468 5.63603897,5.63603897 Z M8.453,11.282 L4.89321881,14.8427125 C3.71572875,16.0202025 3.71572875,17.9292911 4.89321881,19.1067812 C6.02865566,20.242218 7.84436716,20.2827693 9.02839505,19.2284351 L9.15728753,19.1067812 L12.717,15.546 L11.296,14.125 L10.5786438,14.8427125 C10.1861471,15.2352092 9.54978421,15.2352092 9.15728753,14.8427125 C8.76479084,14.4502158 8.76479084,13.8138529 9.15728753,13.4213562 L9.875,12.704 L8.453,11.282 Z M20.5281374,3.47186258 C22.4906209,5.43434601 22.4906209,8.61616033 20.5281374,10.5786438 L17.6854249,13.4213562 C17.2929283,13.8138529 16.6565654,13.8138529 16.2640687,13.4213562 C15.871572,13.0288596 15.871572,12.3924967 16.2640687,12 L19.1067812,9.15728753 C20.2842712,7.97979746 20.2842712,6.07070887 19.1067812,4.89321881 C17.9292911,3.71572875 16.0202025,3.71572875 14.8427125,4.89321881 L12,7.73593129 C11.6075033,8.12842798 10.9711404,8.12842798 10.5786438,7.73593129 C10.1861471,7.3434346 10.1861471,6.70707174 10.5786438,6.31457505 L13.4213562,3.47186258 C15.3838397,1.50937914 18.565654,1.50937914 20.5281374,3.47186258 Z M12.7071068,9.87867966 L11.2928932,11.2928932 L12.7071068,12.7071068 L14.1213203,11.2928932 L12.7071068,9.87867966 Z" />
          </svg>
          Unlink Google Account
        </button>
        <div className='unlink-div'>
          {/* <h4>Google label</h4>
                <p>Omnioutrech automatically sets a Google label to all emails that are sent with OmniOutreach. It also labels replied emails. You can change the name of the label that you will see in your Google mailbox. Clear the label name to stop labelling emails.</p>
                <Form.Group controlId="googlelablename">
                    <Form.Label>
                        Google label name
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="googlelablename"
                        placeholder="Enter Google label name"
                        value="Google Label Name"
                        readOnly
                    />
                </Form.Group> */}
          {/* <button className='solid-button' onClick={() => setSmShow(true)}>Unlink Google account</button> */}
          <Modal
            size="md"
            className='warning-modal'
            show={smShow}
            onHide={() => setSmShow(false)}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className='warning-div'>
                <img src={warningIcon} alt="warning" />
                <h2>Unlink Google Account</h2>
                <p>Unlinking your Google account will ultimately stop all campaigns using that account. Are you sure?
                </p>
                <div className='btn-container'>
                  <button className='cancel-btn' onClick={() => setSmShow(false)}>Cancel</button>
                  <button className='solid-button' onClick={handleUnlink} >Unlink Now</button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </div>
  </>
}

export default withRouter(GoogleEmail);
